(() => {
  const root = document.documentElement;
  let frame = 0;
  let preview = null;
  const update = () => {
    frame = 0;
    const viewport = window.visualViewport;
    const height = viewport ? viewport.height : window.innerHeight;
    const bottom = (viewport ? viewport.offsetTop : 0) + height;
    const bounds = preview ? preview.getBoundingClientRect() : null;
    const inset = bounds && bounds.width > 0 && bounds.height > 0
      ? Math.max(0, Math.min(bounds.height, bottom - bounds.top))
      : 0;
    root.style.setProperty('--sb-search-visible-height', height + 'px');
    root.style.setProperty('--sb-search-bottom-inset', inset + 'px');
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };
  const previewResize = new ResizeObserver(schedule);
  const findPreview = () => {
    const next = document.getElementById('PBarNextFrameWrapper');
    if (next && next !== preview) {
      if (preview) previewResize.unobserve(preview);
      preview = next;
      previewResize.observe(preview);
    }
    schedule();
  };
  window.addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('scroll', schedule, { passive: true });
  const additions = new MutationObserver(findPreview);
  additions.observe(document.body, { childList: true });
  window.addEventListener('pageshow', findPreview);
  findPreview();
})();

(() => {
  const section = document.querySelector('[data-search-collections]');
  if (!section) return;
  const searchUrl = new URL(window.location.href);
  if (searchUrl.searchParams.get('type') !== 'product') {
    searchUrl.searchParams.set('type', 'product');
    searchUrl.searchParams.delete('page');
    window.location.replace(searchUrl);
    return;
  }

  const endpoint = new URL(section.dataset.endpoint, window.location.origin);
  endpoint.searchParams.set('q', section.dataset.query);
  endpoint.searchParams.set('resources[type]', 'collection');
  endpoint.searchParams.set('resources[limit]', '6');
  fetch(endpoint)
    .then(response => response.ok ? response.json() : null)
    .then(data => {
      const collections = data?.resources?.results?.collections ?? [];
      const list = section.querySelector('ul');
      for (const collection of collections) {
        const url = new URL(collection.url, window.location.origin);
        if (url.origin !== window.location.origin) continue;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = url.href;
        link.textContent = collection.title;
        item.append(link);
        list.append(item);
      }
      section.hidden = !list.children.length;
    })
    .catch(() => {});
})();